module.exports = __webpack_public_path__ + "0a04292d86498f8b945c64e9d6c9df79.svg";